const SubscriptionTitleToProductId = {
  'Pro': 'tt-pro-subscription',
  'Premium': 'tt-premium-subscription',
  'Premium Plus': 'tt-premium-plus-subscription',
};

export default SubscriptionTitleToProductId;
